import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import EcGrid from "@/components/widgets/EcGrid.vue";
import Switches from "vue-switches";
import DeleteComponent from "@/components/deleteComponent.vue";
import stepListingMachine from "./machines/stepsListingMachine";
import { interpret } from "xstate";
import { PAStepModule } from "@/store/modules/paStep.module";
import StepUpsertComponent from "./components/StepUpsertComponent.vue";
import OrderStepsComponent from "./components/OrderStepsComponent.vue";
import { toaster } from "@/utilities/toaster";
let Steps = /** @class */ (() => {
    let Steps = class Steps extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Steps";
            this.gridUILoading = false;
            this.stepId = "";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Performance",
                    href: "#",
                },
                {
                    text: "Steps",
                    active: true,
                },
            ];
            this.columns = [
                {
                    field: "name",
                    label: "Step Name",
                    sortable: false,
                },
                {
                    field: "defaultDuration",
                    label: "Duration (Days)",
                    thClass: "step-duration-header",
                    tdClass: "text-center",
                    sortable: false,
                },
                {
                    field: "actions",
                    label: "Actions",
                    thClass: "text-center",
                    sortable: false,
                },
            ];
            this.initialPage = 1;
            this.initialPageSize = 10;
            this.totalCount = 0;
            //   MACHINE
            this.machine = stepListingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        AddStepModal() {
            this.showStep("Add");
        }
        showStep(mode) {
            let stepComponent = this.$refs["stepUpsertComponentRef"];
            stepComponent.showModal(mode, this.stepId);
        }
        closeStepModal() {
            this.$bvModal.hide("add-step");
        }
        editStepModal(stepId) {
            this.stepId = stepId;
            this.showStep("Edit");
        }
        showDeleteModal(stepId) {
            this.stepId = stepId;
            this.machineService.send({ type: "DELETE_STEP" });
        }
        deleteStep() {
            this.machineService.send({ type: "DELETING_STEP", stepId: this.stepId });
        }
        onRowClick() {
            return "";
        }
        SaveOrderedStep(SaveOrderedStep) {
            PAStepModule.updateStepOrder(SaveOrderedStep).then((response) => {
                if (response) {
                    toaster.ShowSuccess("Step order has been updated");
                    this.machineService.send({ type: "GETTING_STEPS" });
                }
                else {
                    toaster.ShowError("operation failed");
                }
            });
        }
        showOrderStepsModal() {
            this.machineService.send({ type: "ORDER_STEP" });
            this.$bvModal.show("order-steps-modal");
        }
        closeOrderStepsModal() {
            this.$bvModal.hide("order-steps-modal");
        }
        get rows() {
            return PAStepModule.steps;
        }
        get employees() {
            return PAStepModule.employees;
        }
        get roles() {
            return PAStepModule.roles;
        }
        get targetAudiences() {
            return PAStepModule.targetAudiences;
        }
        get totalSteps() {
            return PAStepModule.totalCount;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.state = state;
                if (this.state.matches("gettingSteps") || this.state.matches("deletingStep")) {
                    this.gridUILoading = true;
                }
                if (this.state.matches("loadedSteps")) {
                    this.totalCount = this.totalSteps;
                    this.gridUILoading = false;
                    this.stepId = "";
                }
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    Steps = __decorate([
        Component({
            name: "StepListing",
            components: {
                Layout,
                PageHeader,
                Loader,
                EcGrid,
                DeleteComponent,
                Switches,
                StepUpsertComponent,
                OrderStepsComponent,
            },
        })
    ], Steps);
    return Steps;
})();
export default Steps;
